import React from "react";
import { Box, Stack, Typography, CircularProgress } from "@mui/material";
import { tokens } from "../theme/tokens";

/**
 * Full-screen overlay: logo + three pulsing dots + “Loading data…” — no card/box.
 * @param {{ variant?: "overlay" | "inline" }} props
 */
const Loader = ({ variant = "overlay" }) => {
  if (variant === "inline") {
    return <CircularProgress size={22} thickness={4} sx={{ color: "inherit" }} />;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.55)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Stack alignItems="center" spacing={{ xs: 1.75, sm: 2 }}>
        <Box
          component="img"
          src="/images/Wordmark.svg"
          alt="TripTrip"
          sx={{
            height: { xs: 28, sm: 32 },
            width: "auto",
            maxWidth: "min(168px, 72vw)",
            objectFit: "contain",
          }}
        />

        <Stack
          direction="row"
          alignItems="center"
          spacing={1.25}
          sx={{
            pl: 0.5,
            "@keyframes loaderDotPulse": {
              "0%, 100%": {
                opacity: 0.35,
                transform: "scale(0.85)",
              },
              "50%": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.65, sm: 0.75 },
            }}
            aria-hidden
          >
            {[0, 1, 2].map((i) => (
              <Box
                key={i}
                sx={{
                  width: { xs: 7, sm: 8 },
                  height: { xs: 7, sm: 8 },
                  borderRadius: "50%",
                  bgcolor: tokens.brand,
                  animation: "loaderDotPulse 1.05s ease-in-out infinite",
                  animationDelay: `${i * 0.16}s`,
                }}
              />
            ))}
          </Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: { xs: "0.78rem", sm: "0.82rem" },
              color: tokens.accent,
              letterSpacing: "0.02em",
            }}
          >
            Loading data...
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Loader;
